import ISingleMediaSlideData from '@app/types/data/slides/ISingleMediaSlideData';
import ISlideMaster from '@app/types/presentations/master/ISlideMaster';
import { Transformation } from 'cloudinary-core';
import IPresentationSettings from '../../types/presentations/presentation/IPresentationSettings';
import AbstractSlideTransform from './AbstractSlideTransform';

/**
 * Transform for 021-SingleMediaSlide
 */
export default class SingleMediaSlideTransform extends AbstractSlideTransform {
	public viewComponent: string = 'SingleMediaSlide';

	public async transform(
		slide: ISlideMaster,
		_presentationSettings: IPresentationSettings //  eslint-disable-line @typescript-eslint/no-unused-vars
	): Promise<ISingleMediaSlideData> {
		const imageTransformOptions: Transformation.Options = {
			width: 5000,
			height: 5000,
			crop: 'limit'
		};

		const data: ISingleMediaSlideData = {
			id: slide.id,
			label: slide.fields.label || slide.fields.headline,
			shareViewSection: slide.fields.shareViewSection === 'special-info' ? 'special-info' : undefined,
			thumbnail: this.extractThumbnail(slide.fields.headline, slide, 'image'),
			image: this.transformImageAsset(
				slide.fields.image?.fields.asset ?? this.getFallbackImage(),
				imageTransformOptions
			)
		};

		if (slide.fields.video && slide.fields.video.fields.asset) {
			data.video = this.transformVideoAsset(slide.fields.video.fields.asset);
			data.loopVideo = slide.fields.loopVideo === true;
		}
		// TODO: remove this PR is rolled out and content type HighlightSlide's field 'videoLoop' has been renamed to 'video'
		else if (slide.fields.videoLoop && slide.fields.videoLoop.fields.asset) {
			data.video = this.transformVideoAsset(slide.fields.videoLoop.fields.asset);
		}

		if (slide.fields.logo && slide.fields.logo.fields.asset) {
			data.logo = {
				...this.transformImageAsset(slide.fields.logo.fields.asset, {
					width: 390,
					height: 250,
					crop: 'limit'
				}),
				alt: slide.fields.logo.fields.title
			};
		}

		return data;
	}
}
